<template>
	<div ref="rightPanel" class="rightPanel-container" :style="{ bottom: `${bottom}px` }">
		<button class="handler-button" @click.stop="onClick">分享</button>
	</div>
</template>

<script>
export default {
	props: {
		bottom: {
			type: Number,
			default: 80
		}
	},
	methods: {
		onClick () {
			this.$emit('on-click')
		}
	}
}
</script>

<style scoped>
.rightPanel-container{
	position: fixed;
	right: 0;
	z-index: 99;
}
.handler-button{
	width: 42px;
	height: 42px;
	color: #fff;
	border: 0 none;
	background: url(../assets/icon-share.png) no-repeat;
	background-size: 100%;
	border-radius: 5px;
	font-size: 0;
}
</style>



// WEBPACK FOOTER //
// SideFloat.vue?4905bef6